import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=f0ce0d1c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=f0ce0d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ce0d1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0ce0d1c')) {
      api.createRecord('f0ce0d1c', component.options)
    } else {
      api.reload('f0ce0d1c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=f0ce0d1c&scoped=true&", function () {
      api.rerender('f0ce0d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mtGsiPAh5fBw/JS/comp/Voucher.vue"
export default component.exports